import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    linkActiveClass: 'active',
    routes: [{
            path: '/',
            name: 'index',
            redirect: '/Caselist',
            component: resolve => require(['@/components/Wrap'], resolve),
            children: [{
                    path: '/Caselist',
                    name: 'Caselist',
                    component: resolve => require(['@/components/Caselist'], resolve),

                },
                // 演示病例列表
                {
                    path: 'Caselist/sampleCaselist',
                    name: 'sampleCaselist',
                    component: resolve => require(['@/components/CaselistSample'], resolve)
                },
                // 患者筛选列表
                {
                    path: 'patientSearch',
                    name: 'patientSearch',
                    component: resolve => require(['@/components/patientSearch'], resolve),
                    redirect: '/patientSearch/list',
                    children: [{
                            path: 'list',
                            name: 'patientlist',
                            component: resolve => require(['@/components/patientSearch/list'], resolve)
                        },
                        /* 患者首页 */
                        {
                            path: 'patientIndex/:id/:pid/:status',
                            name: 'patientlist_patientIndex',
                            meta: {
                                text: '患者'
                            },
                            component: resolve => require(['@/components/patient/patientIndex'], resolve)
                        },
                    ]
                },
                {
                    path: '/cases',
                    name: 'cases',
                    component: resolve => require(['@/components/cases/index'], resolve)
                },
                // 演示病例
                {
                    path: '/samplecases',
                    name: 'samplecases',
                    component: resolve => require(['@/components/cases/index'], resolve)
                },
                {
                    path: '/casesspeedy',
                    name: 'casesspeedy',
                    component: resolve => require(['@/components/casesspeedy/index'], resolve)
                },
                /* 版本更新 */
                {
                    path: '/version',
                    name: 'version',
                    component: resolve => require(['@/components/version'], resolve)
                },
                /* 演示病例患者首页 */
                {
                    path: 'Caselist/samplepatientIndex/:id/:pid/:status',
                    name: 'Caselist/samplepatientIndex/:id/:pid/:status',
                    meta: {
                        text: '病例列表'
                    },
                    component: resolve => require(['@/components/patient/patientIndex'], resolve)
                },
                /* 患者首页 */
                {
                    path: 'Caselist/patientIndex/:id/:pid/:status',
                    name: 'Caselist/patientIndex/:id/:pid/:status',
                    meta: {
                        text: '病例列表'
                    },
                    component: resolve => require(['@/components/patient/patientIndex'], resolve)
                },

                {
                    path: '/stageView',
                    name: 'stageView',
                    component: resolve => require(['@/components/patient/stageView'], resolve)
                },
                /* 确认收费单 */
                {
                    path: '/confirmCharge/:pid/:cid/:action',
                    name: 'confirmCharge/:pid/:cid/:action',
                    component: resolve => require(['@/components/patient/confirmCharge'], resolve)
                },
                /* 找回密码 */
                {
                    path: '/forgot',
                    name: 'forgot',
                    meta: {
                        notoken: true,
                    },
                    component: resolve => require(['@/components/usercenter/forgot'], resolve)
                },
                /* 个人中心 */
                {
                    path: '/userCenter',
                    name: 'userCenter',
                    component: resolve => require(['@/components/userCenter/'], resolve),
                    redirect: 'userCenter/accounts',
                    children: [
                        // {
                        //     path: 'basic',
                        //     name: 'userBasic',
                        //     component: resolve => require(['@/components/userCenter/basic'], resolve),
                        // },
                        {
                            path: 'setting',
                            name: 'usersetting',
                            component: resolve => require(['@/components/userCenter/setting'], resolve)
                        },
                        {
                            path: 'address',
                            name: 'userAddress',
                            component: resolve => require(['@/components/userCenter/address'], resolve)
                        },
                        {
                            path: 'accounts',
                            name: 'accounts',
                            component: resolve => require(['@/components/userCenter/accounts/index'], resolve)
                        }
                    ]
                },
                {
                    path: '/preferenceSet',
                    name: 'preferenceSet',
                    component: resolve => require(['@/components/preferenceSet'], resolve)
                },
                {
                    path: '/freeDelivery',
                    name: 'freeDelivery',
                    component: resolve => require(['@/components/freeDelivery/index.vue'], resolve)
                },
                {
                    path: '/deliveryhelp',
                    name: 'deliveryhelp',
                    component: resolve => require(['@/components/freeDelivery/usehelp.vue'], resolve)
                },
                {
                    path: '/delivery/:id', // 寄送订单列表 id参数 1 表示查看寄送二维码 2表示查看已下单快递
                    name: 'delivery',
                    component: resolve => require(['@/components/freeDelivery/orderList.vue'], resolve)
                },
                {
                    path: '/costList',
                    name: 'coseList',
                    component: resolve => require(['@/components/costList'], resolve)
                },
                /* 根骨学院 */
                {
                    path: '/academy',
                    name: 'academy',
                    component: resolve => require(['@/components/live/index'], resolve),
                    redirect: 'academy/news',
                    children: [{
                            path: 'news',
                            name: 'news',
                            component: resolve => require(['@/components/live/news'], resolve)
                        },
                        {
                            path: 'live',
                            name: 'live',
                            component: resolve => require(['@/components/live/live'], resolve)
                        },
                        {
                            path: 'videolist',
                            name: 'videolist',
                            component: resolve => require(['@/components/live/videolist'], resolve)
                        }
                    ]
                },
                {
                    path: 'academy/liveroom/:id',
                    name: 'liveroom',
                    component: resolve => require(['@/components/live/liveroom'], resolve)
                },
                {
                    path: 'academy/newsdetail/:id',
                    name: 'newsdetail',
                    component: resolve => require(['@/components/live/newsdetail'], resolve)
                },
                {
                    path: 'academy/videodetail/:id',
                    name: 'videodetail',
                    component: resolve => require(['@/components/live/videodetail'], resolve)
                },
                /* 付款记录 */
                {
                    path: 'paylist',
                    name: 'paylist',
                    component: resolve => require(['@/components/pay/paylist'], resolve)
                },
                {
                    path: 'paydetail/:id/:caseid',
                    name: 'paydetail',
                    component: resolve => require(['@/components/pay/paydetail'], resolve)
                },
                {
                    path: 'invoice/:type',
                    name: 'invoice',
                    component: resolve => require(['@/components/pay/invoice'], resolve)
                }
            ]
        },
        {
            path: '/sampleweb3D',
            name: 'sampleweb3D',
            component: resolve => require(['@/components/web3D'], resolve)
        },
        {
            path: '/web3D',
            name: 'web3D',
            meta: {
                notoken: true,
            },
            component: resolve => require(['@/components/web3D'], resolve)
        },
        {
            path: '/web3Dshare',
            name: 'web3Dshare',
            meta: {
                notoken: true,
            },
            component: resolve => require(['@/components/web3Dshare'], resolve)
        },
        {
            path: '/3dFeedback',
            name: '3dFeedback',

            component: resolve => require(['@/components/3dFeedback'], resolve)
        },

        {
            path: '/login',
            name: 'login',
            meta: {
                notoken: true,
            },
            component: resolve => require(['@/components/usercenter/login'], resolve)
        },
        {
            path: '/xdocument',
            name: 'xdocument',
            component: resolve => require(['@/components/Xdocument'], resolve)
        },
        {
            path: '/shortCode',
            name: 'shortCode',
            component: resolve => require(['@/components/modal/shortCode'], resolve)
        },
        {
            path: '/register',
            name: 'register',
            meta: {
                notoken: true,
            },
            component: resolve => require(['@/components/register'], resolve)
        },
        {
            path: '/HtmlPanel',
            name: 'HtmlPanel',
            meta: {
                notoken: true,
            },
            component: resolve => require(['@/components/HtmlPanel'], resolve)
        },
        {
            path: '/worksheetPreview/:token/:case_id/:patient_id',
            name: 'worksheetPreview',
            meta: {
                notoken: true,
            },
            component: resolve => require(['@/components/worksheetPreview'], resolve)
        },
        {
            path: '/redirect',
            name: 'redirect',
            meta: {
                notoken: true,
            },
            component: resolve => require(['@/components/redirect'], resolve)
        },
        // 内部连接跳转
        {
           path: '/x/:id',
           name: 'interim',
           meta: {
            notoken: true,
           },
           component: resolve => require(['@/components/interim'], resolve)
        },
        {
            path: '/t',
            name: 'otherInterim',
            meta: {
                notoken: true
            },
            component: resolve => require(['@/components/otherInterim'], resolve)
        }
    ]
});
router.beforeEach((to, from, next) => {
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', to.fullPath]);
        }
    }
    // 工厂端跳转链接有传token替换当前token
    if (to.query.token) {
        localStorage.token = to.query.token;
    }
    // console.log(to.meta.notoken,'////')
    // console.log(localStorage.token)
    // return
    if (to.meta.notoken && to.meta.notoken == true) {
        //if (to.path == '/login' || to.path == '/forgot' || to.path == '/web3D' || to.path == '/register' || to.name == 'worksheetPreview' || to.name =='HtmlPanel') {
        next();
        return;
    }
    if (localStorage.userData === undefined) {
        next('/login');
        return;
    }
    next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js